const HEX6 = /^#?([0-9a-f]{6})$/i;

/** Returns lowercase `#rrggbb` or `null` if invalid. */
export function normalizeStitchColorInput(value: string): string | null {
    const m = value.trim().match(HEX6);
    if (!m) return null;
    return `#${m[1]!.toLowerCase()}`;
}

export const DEFAULT_STITCH_COLOR: string = '#000000' as const;

/** Packed 0xRRGGBB number for a stored stitch color, or `null` when the
 *  value is absent or not a 6-digit hex color. */
export function stitchColorToNumber(color: string | undefined): number | null {
    if (color == null) return null;
    const norm = normalizeStitchColorInput(color);
    if (norm == null) return null;
    return parseInt(norm.slice(1), 16);
}
